import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

// Services
import { LoggerService } from '../../services/logger/logger.service';

@Injectable({ providedIn: 'root' })
export class KeyboardUtils {
  public keyboardOpened: boolean = false;

  private keyboardHeight: number;

  constructor(
    private platform: Platform,
    private logger: LoggerService,
  ) {}

  /**
   * @readonly
   * @type {string}
   * @memberof KeyboardUtils
   */
  get appContentHeight(): string {
    return !this.keyboardOpened ? '100%' : `calc(100% - ${this.keyboardHeight ?? 0}px) !important`;
  }

  /**
   * @memberof KeyboardUtils
   */
  public listenKeyboardChanges(): void {
    this.logger.consoleLog('KeyboardUtils', 'listenKeyboardChanges', [this.keyboardHeight ?? 0]);

    this.platform
      .ready()
      .then((platform) => {
        this.logger.consoleLog('KeyboardUtils', 'listenKeyboardChanges', platform);

        this.platform.keyboardDidShow.subscribe((event) => {
          this.keyboardHeight = event.keyboardHeight;
          this.keyboardOpened = true;

          this.logger.consoleLog('KeyboardUtils', 'listenKeyboardChanges > keyboardDidShow', {
            keyboardHeight: this.keyboardHeight,
            keyboardOpen: this.keyboardOpened,
            appContentHeight: this.appContentHeight,
          });
        });

        this.platform.keyboardDidHide.subscribe(() => {
          this.keyboardHeight = 0;
          this.keyboardOpened = false;

          this.logger.consoleLog('KeyboardUtils', 'listenKeyboardChanges > keyboardDidHide', {
            keyboardHeight: this.keyboardHeight,
            keyboardOpen: this.keyboardOpened,
            appContentHeight: this.appContentHeight,
          });
        });
      })
      .catch((error) => {
        this.logger.consoleError('KeyboardUtils', 'listenKeyboardChanges', error);
      });
  }
}
